import { defineMessages } from 'react-intl';

/** The head, the period picker, the section chips and the plan limit (design your-intelligence §10). */
export const streamingMessages = defineMessages({
  title: { id: 'app.sml.streaming.title', defaultMessage: 'Streaming' },
  description: {
    id: 'app.sml.streaming.description',
    defaultMessage:
      'Your real numbers from the sources you connected: streams, listeners, stores, countries, playlists and earnings, day by day.',
  },
  periodLabel: { id: 'app.sml.streaming.period.label', defaultMessage: 'Period' },
  periodDays: { id: 'app.sml.streaming.period.days', defaultMessage: '{days}d' },
  periodDates: {
    id: 'app.sml.streaming.period.dates',
    defaultMessage: '{start} – {end} · against {prevStart} – {prevEnd}',
  },
  periodDatesNoPrevious: { id: 'app.sml.streaming.period.datesNoPrevious', defaultMessage: '{start} – {end}' },
  chipsLabel: { id: 'app.sml.streaming.chips.label', defaultMessage: 'Sections' },
  chipOverview: { id: 'app.sml.streaming.chip.overview', defaultMessage: 'Overview' },
  chipTracks: { id: 'app.sml.streaming.chip.tracks', defaultMessage: 'Tracks' },
  chipStores: { id: 'app.sml.streaming.chip.stores', defaultMessage: 'Stores' },
  chipCountries: { id: 'app.sml.streaming.chip.countries', defaultMessage: 'Countries' },
  chipAudience: { id: 'app.sml.streaming.chip.audience', defaultMessage: 'Audience' },
  chipPlaySources: { id: 'app.sml.streaming.chip.playSources', defaultMessage: 'Play sources' },
  chipShortVideo: { id: 'app.sml.streaming.chip.shortVideo', defaultMessage: 'Short video' },
  chipAccelerator: { id: 'app.sml.streaming.chip.accelerator', defaultMessage: 'Accelerator' },
  chipPlaylists: { id: 'app.sml.streaming.chip.playlists', defaultMessage: 'Playlists' },
  chipEarnings: { id: 'app.sml.streaming.chip.earnings', defaultMessage: 'Earnings' },
  sourcesLabel: { id: 'app.sml.streaming.sources.label', defaultMessage: 'Sources' },
  sourceTurnOff: { id: 'app.sml.streaming.source.turnOff', defaultMessage: 'Turn {source} off in the numbers' },
  upgradeChip: { id: 'app.sml.streaming.upgrade.chip', defaultMessage: 'Needs the {plan} plan' },
  upgradeTitle: { id: 'app.sml.streaming.upgrade.title', defaultMessage: 'See {days} days of your numbers' },
  upgradeText: {
    id: 'app.sml.streaming.upgrade.text',
    defaultMessage:
      '{currentPlan} shows {currentDays} days. MUSIC24 keeps all the history your sources have, so your older numbers are ready the moment you upgrade.',
  },
  upgradeButton: { id: 'app.sml.streaming.upgrade.button', defaultMessage: 'See plans' },
  upgradeNotNow: { id: 'app.sml.streaming.upgrade.notNow', defaultMessage: 'Not now' },
});
